module.exports = __webpack_public_path__ + "static/img/sempty.261ea71.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/sempty.png
// module id = ZynT
// module chunks = 15